import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css$e = ".Divider_module_container__1fb7194e{align-items:center;display:flex;gap:var(--st-spacing-2);line-height:var(--st-line-height-xs)}.Divider_module_bar__1fb7194e{border-bottom:1px solid var(--st-divider-color);flex:1 1 auto}";
collectCss(css$e);
var modules_979bfa57 = {"container":"Divider_module_container__1fb7194e","bar":"Divider_module_bar__1fb7194e"};

export { css$e as css, modules_979bfa57 as default };
//# sourceMappingURL=Divider.module.css.mjs.map
